// extracted by mini-css-extract-plugin
module.exports = {"container":"one-column-section_container___9O8s","imageWrapper":"one-column-section_imageWrapper__U4DpL"};